export default __webpack_public_path__ + "static/media/linkedin.6810a25f.webp";